import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useGet } from "../../customHooks/useGet";
import { FaPlusCircle, FaTimesCircle, FaTrash } from "react-icons/fa";
import { post, get } from "../../services/Services";
import { Form, Button, Spinner } from 'react-bootstrap';
function EventForm({ onSubmit, eventData = {}, setShowForm }) {
  const [formData, setFormData] = useState({
    city: eventData.city || "",
    competitionNumber: eventData.competitionNumber || "",
    name: eventData.name || "",
    eventDate: eventData.eventDate || "",
    eventEndDate: eventData.eventEndDate || "",
    startDate: eventData.startDate || "",
    endDate: eventData.endDate || "",
    paymentConditions: eventData.paymentConditions || [
      { endDate: "", discountPercentage: "", interestPercentage: "", minPerformances: "" }
    ],
    forms: eventData.forms || [],
    categories: eventData.categories || [],
    modalities: eventData.modalities || [],
    status: eventData.status || false,
    paymentType: "Pago normal",
    price_choreography: eventData.price_choreography || "", // <- NUEVO CAMPO
    
  });

  const [provinces, setProvinces] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [showPaymentConditions, setShowPaymentConditions] = useState(false);

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { data: formsData } = useGet("/api/academy/forms?page=0&size=80");
  const { data: categoriesData } = useGet("/api/academy/categories?page=0&size=80");
  const { data: modalitiesData } = useGet("/api/academy/modalities?page=0&size=80");

  const [options, setOptions] = useState({
    forms: [],
    categories: [],
    modalities: [],
  });

  useEffect(() => {
    setOptions({
      forms: formsData?.content || [],
      categories: categoriesData?.content || [],
      modalities: modalitiesData?.content || [],
    });
  }, [formsData, categoriesData, modalitiesData]);

  useEffect(() => {
    async function fetchProvinces() {
      try {
        const response = await get("https://ectech-software.com.ar/api/core/provinces?page=0&size=5000");
        setProvinces(response.data.content || []);
      } catch (error) {
        console.error("Error cargando provincias:", error);
      }
    }
    fetchProvinces();
  }, []);

  const handleProvinceChange = (e) => {
    setSelectedProvince(e.target.value);
    // También puedes guardar esta info en formData si quieres enviarla al backend
    setFormData((prev) => ({
      ...prev,
      provinceId: e.target.value,
      city: "",  // Resetear ciudad al cambiar provincia
    }));
  };
  const handleCityChange = (e) => {
    setSelectedCity(e.target.value);
    setFormData((prev) => ({
      ...prev,
      city: e.target.value,
    }));
  };

  useEffect(() => {
    async function fetchCities() {
      if (!selectedProvince) {
        setCities([]);
        setSelectedCity("");
        return;
      }
      try {
        const response = await get(`https://ectech-software.com.ar/api/core/provinces/${selectedProvince}/cities?page=0&size=5000`);
        setCities(response.data.content || []);
      } catch (error) {
        console.error("Error cargando ciudades:", error);
        setCities([]);
      }
    }
    fetchCities();
  }, [selectedProvince]);

  const capitalizeWords = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : capitalizeWords(value),
    }));
  };

  const handleFormSelection = (id, isChecked) => {
    setFormData((prev) => {
      const formToAdd = options.forms.find((f) => f.id === id);
      const updatedForms = isChecked
        ? [...prev.forms, { id: formToAdd.id, name: formToAdd.name, price: "" }]
        : prev.forms.filter((form) => form.id !== id);
      return { ...prev, forms: updatedForms };
    });
  };


  const handlePriceChange = (id, price) => {
    setFormData((prev) => ({
      ...prev,
      forms: prev.forms.map((form) =>
        form.id === id
          ? { ...form, price } // Guardamos el texto tal como lo escribe
          : form
      ),
    }));
  };


  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "El nombre del evento es obligatorio.";
    if (!formData.eventDate) newErrors.eventDate = "La fecha de Inicio de evento es obligatoria.";
    if (!formData.eventEndDate) newErrors.eventEndDate = "La fecha de fin de evento es obligatoria.";
    if (!formData.startDate) newErrors.startDate = "La fecha de inicio de Inscripción es obligatoria.";
    if (!formData.endDate) newErrors.endDate = "La fecha de cierre de Inscripción es obligatoria.";



    return newErrors;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);
    try {
      const formattedData = {
        name: formData.name,
        config: {
          city: {id: parseInt(formData.city, 10)},
          competitionNumber: formData.competitionNumber,
          eventDate: formData.eventDate,
          eventEndDate: formData.eventEndDate,
          registrationStartDate: formData.startDate,
          registrationEndDate: formData.endDate,
          status: {
            id: formData.status ? 1 : 2,
          },
          categories: formData.categories.map(cat => ({
            id: cat.id,
          })),
          forms: formData.forms.map(form => ({
            id: form.id,
            price: form.price,
          })),
          modalities: formData.modalities.map(mod => ({
            id: mod.id,
          })),
          priceChoreography: formData.price_choreography,
          paymentConditions: formData.paymentConditions.map(cond => ({
            startDate: cond.startDate,
            endDate: cond.dueDate, // ⚠️ Este campo es requerido por el backend
            discountPercentage: cond.type === 'discount' ? cond.amount : 0,
            interestPercentage: cond.type === 'interest' ? cond.amount : 0,
            minPerformances: cond.minPerformances || 0,
            status: true,
            
          }))
        }
      };
      await onSubmit(formattedData);
      setShowForm(false);

    } catch (error) {
      console.error("Error al crear el evento:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    setShowForm(false);
  };


  const handlePaymentTypeChange = (index, value) => {
    const updatedConditions = [...formData.paymentConditions];
    updatedConditions[index].paymentType = value;
    setFormData({ ...formData, paymentConditions: updatedConditions });
  };

  const handlePaymentConditionChange = (index, field, value) => {
    const updatedConditions = [...formData.paymentConditions];
    updatedConditions[index][field] = value;
    setFormData({ ...formData, paymentConditions: updatedConditions });
  };

  const addPaymentCondition = () => {
    setFormData((prev) => ({
      ...prev,
      paymentConditions: [
        ...prev.paymentConditions,
        {
          paymentType: "Pago normal",
          startDate: "",
          discountPercentage: "0", // aseguramos valor por defecto
          interestPercentage: "0", // aseguramos valor por defecto
          minPerformances: "0", // aseguramos valor por defecto
          status: 1,
        },
      ],
    }));
  };


  const removePaymentCondition = (index) => {
    const updatedConditions = formData.paymentConditions.filter((_, i) => i !== index);
    setFormData({ ...formData, paymentConditions: updatedConditions });
  };


  const handleRemovePaymentCondition = (index) => {
    const updated = [...formData.paymentConditions];
    updated.splice(index, 1);
    setFormData({ ...formData, paymentConditions: updated });
  };

  const handleAddPaymentCondition = () => {
    setFormData({
      ...formData,
      paymentConditions: [
        ...formData.paymentConditions,
        {
          type: 'normal',
          amount: 0,
          dueDate: '',
          minPerformances: undefined
        },
      ],
    });
  };


  const handleChangeUpperCase = (e) => {
  const { name, type, checked, value } = e.target;

  const transformValue = () => {
    if (type === "checkbox") return checked;

    // Si es competition_number → todo en mayúscula
    if (name === "competitionNumber") return value.toUpperCase();

    // Para otros campos → capitalizar palabras
    return capitalizeWords(value);
  };

  setFormData((prev) => ({
    ...prev,
    [name]: transformValue(),
  }));
};

  return (
    <div className="container mt-4">
      <div className="card shadow-lg p-4 w-100" style={{ maxWidth: "600px", margin: "auto" }}>
        <div className="card-header bg-primary text-white text-center">
          <h5 className="mb-0">Crear Evento</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            {/* Información General */}
            <h6 className="mt-3">Información General</h6>
            <div className="form-floating mb-3">
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
              />
              <label htmlFor="name">Nombre del evento</label>
              {errors.name && <div className="invalid-feedback">{errors.name}</div>}
            </div>

            {/* Fechas del Evento */}
            <h6 className="mt-4">Fechas del Evento</h6>
            {["eventDate", "eventEndDate"].map((field) => (
              <div className="form-floating mb-3" key={field}>
                <input
                  type="date"
                  id={field}
                  name={field}
                  value={formData[field]}
                  onChange={handleChange}
                  className={`form-control ${errors[field] ? "is-invalid" : ""}`}
                />
                <label htmlFor={field}>
                  {field === "eventDate" ? "Fecha del evento" : "Fecha fin del evento"}
                </label>
                {errors[field] && <div className="invalid-feedback">{errors[field]}</div>}
              </div>
            ))}

            {/* Fechas de Inscripción */}
            <h6 className="mt-4">Fechas de Inscripción</h6>
            {["startDate", "endDate"].map((field) => (
              <div className="form-floating mb-3" key={field}>
                <input
                  type="date"
                  id={field}
                  name={field}
                  value={formData[field]}
                  onChange={handleChange}
                  className={`form-control ${errors[field] ? "is-invalid" : ""}`}
                />
                <label htmlFor={field}>
                  {{
                    startDate: "Fecha de inicio de inscripción",
                    endDate: "Fecha de cierre de inscripción",
                    Start_Date: "Fecha con descuento",
                    Interest_Date: "Fecha con Interés",
                  }[field]}
                </label>
                {errors[field] && <div className="invalid-feedback">{errors[field]}</div>}
              </div>
            ))}
            <div className="form-floating mb-3">

            </div>
            {/* Categorías */}
            <h6 className="mt-4">Categorías</h6>
            <div className="mb-3">
              <select
                multiple
                className="form-select"
                value={formData.categories.map((c) => c.id.toString())}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    categories: Array.from(e.target.selectedOptions).map((opt) => ({
                      id: parseInt(opt.value),
                      name: opt.text,
                    })),
                  }))
                }

              >
                {options.categories.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>








            {/* Modalidades */}
            <h6 className="mt-4">Modalidades</h6>
            <div className="mb-3">
              <select
                multiple
                className="form-select"
                value={formData.modalities.map((m) => m.id.toString())}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    modalities: Array.from(e.target.selectedOptions).map((opt) => ({
                      id: parseInt(opt.value),
                      name: opt.text,
                    })),
                  }))
                }
              >
                {options.modalities.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            <Form.Group className="mb-4">
              <Form.Label>Condiciones de Pago</Form.Label>
              <div className="table-responsive">
                <table className="table table-bordered align-middle">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: "15%" }}>Tipo</th>
                      <th style={{ width: "15%" }}>%</th>
                      <th style={{ width: "20%" }}>Fecha Límite</th>
                      <th style={{ width: "20%" }}>Mín. Obras</th>
                      <th style={{ width: "15%" }}>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.paymentConditions.map((cond, i) => (
                      <tr key={i}>
                        <td>
                          <Form.Select
                            value={cond.type}
                            onChange={(e) => handlePaymentConditionChange(i, 'type', e.target.value)}
                          >
                            <option value="normal">Normal</option>
                            <option value="discount">Descuento</option>
                            <option value="interest">Interés</option>
                          </Form.Select>
                        </td>
                        <td>
                          <Form.Control
                            type="number"
                            placeholder="Importe / %"
                            value={cond.amount}
                            onChange={(e) =>
                              handlePaymentConditionChange(i, 'amount', parseFloat(e.target.value))
                            }
                          />
                        </td>
                        <td>
                          <Form.Control
                            type="date"
                            value={cond.dueDate}
                            onChange={(e) =>
                              handlePaymentConditionChange(i, 'dueDate', e.target.value)
                            }
                          />
                        </td>
                        <td>
                          {cond.type === 'discount' ? (
                            <Form.Control
                              type="number"
                              placeholder="Mínimo obras"
                              value={cond.minPerformances || ''}
                              onChange={(e) =>
                                handlePaymentConditionChange(i, 'minPerformances', parseInt(e.target.value))
                              }
                            />
                          ) : (
                            <span className="text-muted">–</span>
                          )}
                        </td>
                        <td>
                          <Button variant="danger" size="sm" onClick={() => handleRemovePaymentCondition(i)}>
                            <FaTrash />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <Button variant="secondary" onClick={handleAddPaymentCondition}>
                Agregar condición
              </Button>
            </Form.Group>



            {/* Formas y Precios */}
            <h6 className="mt-4">Formas y Precios</h6>
            <div className="mb-3">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Seleccionar</th>
                    <th>Forma</th>
                    <th>Precio (ARS)</th>
                  </tr>
                </thead>
                <tbody>
                  {options.forms.map((form) => (
                    <tr key={form.id}>
                      <td>
                        <input
                          type="checkbox"
                          checked={formData.forms.some((f) => f.id === form.id)}
                          onChange={(e) => handleFormSelection(form.id, e.target.checked)}
                        />
                      </td>
                      <td>{form.name}</td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => handlePriceChange(form.id, e.target.value)}
                          placeholder="$0.00"
                          disabled={!formData.forms.some((f) => f.id === form.id)}
                          value={
                            formData.forms.find((f) => f.id === form.id)?.price || ""
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <h6 className="mt-4">Precio de Coreografía</h6>
            <div className="form-floating mb-3">
              <input
                type="number"
                className="form-control"
                id="price_choreography"
                name="price_choreography"
                value={formData.price_choreography}
                onChange={handleChange}
                min="0"
              />
              <label htmlFor="price_choreography">Precio de Coreografía</label>
            </div>


            <h6 className="mt-4">Provincia y Ciudad</h6>
            <div className="mb-3">
              <select
                className="form-select"
                value={selectedProvince}
                onChange={handleProvinceChange}
                aria-label="Seleccione provincia"
              >
                <option value="">Seleccione una provincia</option>
                {provinces.map((prov) => (
                  <option key={prov.id} value={prov.id}>
                    {prov.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <select
                className="form-select"
                value={selectedCity}
                onChange={handleCityChange}
                disabled={!selectedProvince}
                aria-label="Seleccione ciudad"
              >
                <option value="">Seleccione una ciudad</option>
                {cities.map((city) => (
                  <option key={city.id} value={city.id}>
                    {city.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-floating mb-3">
              <input
                type="text"
                id="competitionNumber"
                name="competitionNumber"
                value={formData.competitionNumber}
                onChange={handleChangeUpperCase}
                className={`form-control ${errors.competition_number ? "is-invalid" : ""}`}
              />
              <label htmlFor="name">Número de Certamen</label>
              {errors.competition_number && <div className="invalid-feedback">{errors.competition_number}</div>}
            </div>

            {/* Estado */}
            <div className="form-check form-switch mb-3">
              <input
                type="checkbox"
                id="status"
                name="status"
                className="form-check-input"
                checked={formData.status}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, status: e.target.checked }))
                }
              />
              <label className="form-check-label" htmlFor="status">
                {formData.status ? "Activado" : "Desactivado"}
              </label>
            </div>


            {/* Botones */}
            <div className="d-flex gap-2">
              <button type="submit" className="btn btn-primary w-50" disabled={isSubmitting}>
                <FaPlusCircle className="me-2" />
                {isSubmitting ? "Guardando..." : "Guardar Evento"}
              </button>
              <button type="button" className="btn btn-secondary w-50" onClick={handleCancel}>
                <FaTimesCircle className="me-2" />
                Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EventForm;
